import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0l1.26.84V7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4z",
  opacity: ".3"
})), 'HomeWorkTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HomeWorkTwoTone.js
// module id = 4154
// module chunks = 2